// language=GraphQL
export const ALL_LANGUAGES_QUERY = `query Query {
  languages: languages {
    id
    name
    slug
  }
}`

// language=GraphQL
export const SINGLE_LANGUAGE_QUERY = `query Query($id: ID!) {
  language: language(id: $id) {
    id
    name
    slug
  }
}`

// language=GraphQL
export const CREATE_LANGUAGE_MUTATION = `
  mutation Mutation($input: CreateLanguageInput) {
    language: createLanguage(input: $input) {
      id
      name
      slug
    }
  }`

// language=GraphQL
export const UPDATE_LANGUAGE_MUTATION = `
  mutation Mutation($input: UpdateLanguageInput) {
    language: updateLanguage(input: $input) {
      id
      name
      slug
    }
  }`

// language=GraphQL
export const DELETE_LANGUAGE_MUTATION = `
  mutation Mutation($input: DeleteLanguageInput) {
    deleteLanguage(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_LANGUAGE_MUTATION = `
  mutation Mutation($input: DeleteLanguageInput) {
    forceDeleteLanguage(input: $input) {
      success
    }
  }`
